import { render, staticRenderFns } from "./InvoiceTemplateNew.vue?vue&type=template&id=79be0004&scoped=true"
import script from "./InvoiceTemplateNew.vue?vue&type=script&lang=js"
export * from "./InvoiceTemplateNew.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTemplateNew.vue?vue&type=style&index=0&id=79be0004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79be0004",
  null
  
)

export default component.exports